import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey:            "AIzaSyCS-Mle5d_SrV2-zArPhRMb9lRfl2J-WrU",
  authDomain:        "rubenology-7179a.firebaseapp.com",
  projectId:         "rubenology-7179a",
  storageBucket:     "rubenology-7179a.firebasestorage.app",
  messagingSenderId: "817062980650",
  appId:             "1:817062980650:web:3061f15b50d8ba05c1e753",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);